export enum BudgetStatus {
  PENDENTE = 1,
  CANCELADO = 2,
  AGUARDANDO_PAGAMENTO = 3,
  DEVOLVIDO = 4,
  AUDITORIA_MEDICA = 5,
  CONFIRMACAO_CLIENTE = 6,
  VALIDADO = 7,
  AUTORIZADO = 8,
  PROCESSADO = 9,
  VALIDADO_SEM_CRITICA = 10,
  EM_DIGITACAO = 11,
  ASSINADO_CLIENTE = 12,
  RECUSADO_CLIENTE = 13,
  CANCELADO_FALTA_PAGAMENTO = 14,
  CANCELADO_DECURSO_PRAZO = 15,
  CANCELAMENTO_DIVERGENCIA_DS = 16,
  VALIDADO_DADOS_DIVERGENTES = 17,
  PAGO_CLIENTE = 18,
  PAGO_VENDEDOR = 19,
  PENDENCIA_MEDICA = 20,
}